import {
    makeStyles,
    createStyles,
    Theme,
    useMediaQuery,
    FormControl,
    InputLabel,
    OutlinedInput,
    InputAdornment,
    OutlinedInputProps,
    IconButton,
    FormHelperText,
} from '@material-ui/core';
import {Visibility, VisibilityOff} from '@material-ui/icons';
import clsx from 'clsx';
import {ReactNode, useEffect, useRef, useState} from 'react';

const useStyles = makeStyles(() =>
    createStyles({
        formControl: {
            width: '100%',
        },
        container: {
            height: 48,
            backgroundColor: 'white',
        },
    }),
);

const CustomPasswordField = ({
    className,
    helperText,
    error,
    fullWidth,
    ...props
}: OutlinedInputProps & {helperText?: ReactNode}) => {
    const isDesktop = useMediaQuery<Theme>(theme => theme.breakpoints.up('sm'));
    const classes = useStyles();
    const labelRef = useRef<HTMLLabelElement>(null);
    const [labelWidth, setLabelWidth] = useState(0);

    const [showPassword, setShowPassword] = useState(false);
    const inputId = props.id || props.name;

    useEffect(() => {
        setLabelWidth(labelRef.current?.offsetWidth || 0);
    }, [props.label]);

    return (
        <FormControl
            className={clsx([classes.formControl, className])}
            error={error}
            fullWidth={fullWidth || !isDesktop}
            variant="outlined"
        >
            {props.label ? (
                <InputLabel ref={labelRef} htmlFor={inputId} error={error}>
                    {props.label}
                </InputLabel>
            ) : null}
            <OutlinedInput
                className={classes.container}
                type={showPassword ? 'text' : 'password'}
                error={error}
                {...props}
                id={inputId}
                labelWidth={labelWidth}
                fullWidth={fullWidth || !isDesktop}
                endAdornment={
                    <InputAdornment position="end">
                        <IconButton
                            aria-label="toggle password visibility"
                            onClick={() => setShowPassword(!showPassword)}
                            edge="end"
                        >
                            {showPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                    </InputAdornment>
                }
            />
            <FormHelperText
                variant="outlined"
                error={error}
                style={{width: isDesktop ? '272px' : '100%'}}
            >
                {helperText}
            </FormHelperText>
        </FormControl>
    );
};

export default CustomPasswordField;
